export default __webpack_public_path__ + "static/literacy-jamaica-32a74067e9976bced9e3d1a9c59bf0f3.png";